
import $ from 'jquery';

const onChangePluscardRadio = ( radioEl ) => {

	var birthdateText = 'Geburtsdatum'

	if ($( radioEl ).val() === 'register_pluscard_new'){
		$('#form_section_register_pluscard_birthdate .input_row_title').first().text(birthdateText + ' *');
		$('#birth-day').addClass('required numberinput');
		$('#month').addClass('required validatename');
		$('#birth-year').addClass('required validateminlength');

	} else {
		$('#form_section_register_pluscard_birthdate .input_row_title').first().text(birthdateText)
		$('#birth-day').removeClass('required numberinput');
		$('#month').removeClass('required validatename');
		$('#birth-year').removeClass('required validateminlength');
	}

	if ( $( radioEl ).val() === 'register_pluscard_none' ){
		$('.address_title').text('Rechnungs-Adresse')
		$('.register_note').removeClass('en_hidden');
		$('.register_note_plc').addClass('en_hidden');
	} else {

		$('.address_title').text('PlusCard-Adresse')
		$('.register_note').addClass('en_hidden');
		$('.register_note_plc').removeClass('en_hidden');
	}
}

$( document ).ready( function() {

	// Initial Value - in case it differs we already toggle here.
	$("[name='blpluscard']:checked").each( function() {
		onChangePluscardRadio( this );
	})

	// Each subsequent click.
	$("[name='blpluscard']").on('change', function(e) {
		onChangePluscardRadio( this );
	})
});
